import { FunctionComponent, useState } from 'react'
import { IUserApplication } from 'Frontend/scripts/models/user.model'
import { Button } from 'react-bootstrap'
import {
  approveMemberApplication,
  deleteUserApplication,
} from 'Frontend/scripts/services/membershipApplication.service'
import { getAntiforgeryToken } from 'Frontend/scripts/services/general.service'
import { IAntiforgeryToken } from 'Frontend/scripts/models/general.model'
import { useTranslation } from 'react-i18next'

interface IApplicationProps {
  applicant: IUserApplication
  callback: () => void
}

const ApplicationItem: FunctionComponent<IApplicationProps> = ({ applicant, callback }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  const approveApplicant = (applicantId: number) => {
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      approveMemberApplication(token.csrfToken, applicantId).then(() => {
        callback()
      })
    })
  }

  const deleteApplicant = (applicantId: number) => {
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      deleteUserApplication(token.csrfToken, applicantId).then(() => {
        callback()
      })
    })
  }

  return (
    <div className="border-bottom">
      <Button className={`member-application__member-row ${isOpen ? 'mb-3' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        {applicant.firstname}&nbsp;{applicant.lastname} <i className={`fa ${isOpen ? 'fa-minus' : 'fa-plus'}`}></i>
      </Button>
      {isOpen && (
        <div className="member-application__detailed-info">
          <div className="row gy-1">
            {applicant?.email && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <span className="fa fa-envelope me-2 workrooms__members-card-icon workrooms__members-card-icon--medium"></span>
                  <label>{t('official-email')}:</label>
                </div>
                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  <a href={`mailto:${applicant?.email}`} className="text-truncate d-block">
                    {applicant?.email}
                  </a>
                </div>
              </>
            )}
            {applicant?.phone && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <label>
                    <span className="fa fa-phone me-2 workrooms__members-card-icon"></span>
                    {t('phone')}:
                  </label>
                </div>
                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  <a href={`tel:${applicant?.phone}`}>{applicant?.phone}</a>
                </div>
              </>
            )}
            {applicant?.mobilePhone && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <label className="d-flex align-items-center">
                    <span className="fa fa-mobile-phone me-2 workrooms__members-card-icon workrooms__members-card-icon--large"></span>
                    {t('mobile-phone')}:
                  </label>
                </div>

                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  <a href={`tel:${applicant?.mobilePhone}`}>{applicant?.mobilePhone}</a>
                </div>
              </>
            )}
            {applicant?.postalAddress && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <label>
                    <span className="fa fa-home me-2 workrooms__members-card-icon"></span>
                    {t('postal-code')}:
                  </label>
                </div>
                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  <p className="mb-0">{applicant?.postalAddress}</p>
                </div>
              </>
            )}
            {applicant?.authority && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <label>{t('authority')}:</label>
                </div>
                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  <p className="mb-0">{applicant?.authority}</p>
                </div>
              </>
            )}
            {applicant?.municipalities?.length > 0 && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <label>{t('municipality')}:</label>
                </div>
                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  {applicant?.municipalities.map((municipality) => (
                    <p key={`municipality-${municipality.id}`} className="mb-0">
                      {municipality.name}
                    </p>
                  ))}
                </div>
              </>
            )}
            {applicant?.county && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <label>{t('county')}:</label>
                </div>
                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  <p className="mb-0">{applicant?.county.name}</p>
                </div>
              </>
            )}

            {applicant?.competenceAreas?.length > 0 && (
              <>
                <div className="col-sm-5 col-xl-4 col-12">
                  <label>{t('competences')}:</label>
                </div>
                <div className="col-sm-7 col-md-7 col-xl-8 col-12">
                  {applicant?.competenceAreas.map((competence) => (
                    <p key={`municipality-${competence.id}`} className="mb-0">
                      {competence.name}
                    </p>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="d-flex justify-content-center gap-3 my-4">
            <Button
              variant="secondary"
              className="gap-2 livstecknet-thread__edit-question"
              onClick={() => approveApplicant(applicant.id)}
            >
              <span className="fa fa-check"></span>
              {t('accept-user')}
            </Button>
            <Button
              variant="dark"
              className="gap-2 livstecknet-thread__edit-question"
              onClick={() => deleteApplicant(applicant.id)}
            >
              <span className="fa fa-trash-o"></span>
              {t('delete-user')}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default ApplicationItem
